export enum SaveSearchFrequencyEnum {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  HOURLY = 'hourly',
  THREE_DAYS = 'three_days',
  OFF = 'off',
}
